import { FC, ReactNode } from 'react';

import styles from './negativeGap.module.css';

export const NegativeGap: FC<{ children: ReactNode }> = ({ children }) => <div className={styles.root}>{children}</div>;
